import React, { useEffect, useRef, useState } from "react";
import { Stack, Button, Typography, IconButton, Box, styled } from "@mui/material";
import WaveSurfer from "wavesurfer.js";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { HostName } from "services/utils/globalVariables";
import moment from 'moment-jalaali';

const VoiceCardContainer = styled(Stack)(
    ({ theme }) => `
        border-radius: 12px;
        width: 80%;
        max-width: 300px;
        border: 1px solid rgba(238, 238, 238, 0.93);
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.10);
        padding: ${theme.spacing(0.5)} ${theme.spacing(1)};
    `
)

const WavesurferContainer = styled(Box)(
    ({ theme }) => `
        width: calc(100% - 82px);
    `
)

//Used Wavesurfer lib for this component

export default function AudioPlayerChatCard({ data, isMine, seen, trigerToBottom }) {

    const mainBackColor = isMine ? "#F9F9F9" : "#FFFFFF"

    const [played, setPlayed] = useState(false)

    const voice = useRef()
    const timer = useRef()
    const playBtn = useRef()

    //wavesurfer init and configs
    useEffect(() => {
        const wavesurfer = WaveSurfer.create({
            container: voice.current,
            url: `${HostName}/${data.Attachment}`,
            waveColor: '#B3B3B3',
            progressColor: '#000000',
            barWidth: 4,
            height: 25,
            barRadius: 4,
            barHeight: 6,
            dragToSeek: true
        })

        //when clicked on "play" will call this function
        playBtn.current.onclick = () => {
            setPlayed(state => !state)
            wavesurfer.playPause()
            updateTimer()
        }

        //updates timer to user see the remaining time
        const updateTimer = () => {
            timer.current.innerText = secondsToTimestamp(wavesurfer.getCurrentTime())
        }

        //other functions for wavesurfer
        wavesurfer.on('ready', () => {updateTimer(); timer.current.innerText = secondsToTimestamp(wavesurfer.getDuration())})
        wavesurfer.on('seeking', updateTimer)
        wavesurfer.on('audioprocess', updateTimer)
        wavesurfer.on("finish", () => {wavesurfer.stop(); setPlayed(false); setTimeout(() => timer.current.innerText = secondsToTimestamp(wavesurfer.getDuration()), 100)})

    }, [])

    //turning seconds to time
    function secondsToTimestamp(seconds) {
        seconds = Math.floor(seconds);
        var h = Math.floor(seconds / 3600);
        var m = Math.floor((seconds - (h * 3600)) / 60);
        var s = seconds - (h * 3600) - (m * 60);

        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        return m + ':' + s;
    }

    //again scroll to bottom system
    useEffect(() => {
        if(trigerToBottom) {
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        }
    }, [])

    return(
        <Stack alignItems={isMine ? "flex-start" : "flex-end"}>
            <VoiceCardContainer sx={{background: mainBackColor}}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography fontWeight="bold" ref={timer} variant="body2">00:00</Typography>
                    <WavesurferContainer>
                        <div className="VoiceContainer" ref={voice}></div>
                    </WavesurferContainer>
                    <IconButton ref={playBtn}>
                        {
                            played ?
                            <PauseIcon />
                            :
                            <PlayArrowIcon />
                        }
                    </IconButton>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    {
                        isMine &&
                        (
                            seen ?
                            <DoneAllIcon fontSize="14px" color="success" />
                            :
                            <CheckIcon fontSize="14px" color="success" />
                        )
                    }
                    <Typography variant="caption" color="text.secondary">{moment(data.CreatedDate).format("HH:mm")}</Typography>
                </Stack>
            </VoiceCardContainer>
        </Stack>
    )
}